/* eslint-disable */
export default {
  onSearching: 'Loading...',
  noContacts: 'No records found.',
} as const;

// @key: @#@"onSearching"@#@ @source: @#@"Loading..."@#@
// @key: @#@"noContacts"@#@ @source: @#@"No records found."@#@
